import { render } from "./Approve_Leave_Request_Modal.vue?vue&type=template&id=4b5bdd6d"
import script from "./Approve_Leave_Request_Modal.vue?vue&type=script&lang=js"
export * from "./Approve_Leave_Request_Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__